<template>
  <div
    class="block-wrapper"
    :class="{
      'over': isBackdropVisible
    }"
    @click.prevent="expandCollapseTrigger('chart')"
  >
    <div class="toolbar">
      <div class="toolbar-actions">
        <div v-if="isShowSubmissionControl" class="action-submission">
          <div class="submission-control">
            <span v-if="slideActive.stopSubmission" class="px-2">
              <aha-icon
                width="28"
                height="28"
                name="lock-sub"
                viewBox="0 0 28 28"
              ></aha-icon>
            </span>
            <span
              v-if="slideActive.stopSubmission"
              class="font-bold"
            >
              {{ $i18nPresenter.t('Submission_closed') }}
            </span>
            <span
              v-if="!slideActive.stopSubmission && !hasTimeLimit"
              class="font-bold px-3 py-2 cursor-pointer"
              @click.stop="toggleSubmission()"
            >{{ $i18nPresenter.t('close_submission') }}</span>
            <span
              v-if="slideActive.stopSubmission"
              class="btn ml-3 cursor-pointer capitalize"
              @click.stop="toggleSubmission()"
            >{{ $i18nPresenter.t('open') }}</span>
            <TimeSubmission
              v-if="isInitTimeSubmission"
              v-show="!slideActive.stopSubmission"
            />
          </div>
        </div>
        <div
          v-if="hasImage"
          class="action-collapse p-2 ml-1 mr-2"
        >
          <span
            v-if="questionImageLayoutMode === 'chart'"
            class="flex-center cursor-pointer text-2xl"
            @click.stop="expandCollapseTrigger('default')"
          >
            <i class="fas fa-compress-alt __icon"></i>
          </span>
          <span
            v-else-if="questionImageLayoutMode === 'default'"
            class="flex-center cursor-pointer text-2xl"
            @click.stop="expandCollapseTrigger('chart')"
          >
            <i class="fas fa-expand-alt __icon"></i>
          </span>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Config from '@/config'
import Util from '@/util'
import Socket from '@/socket'
import TimeSubmission from './TimeSubmissionV2.vue'

export default {
  components: {
    TimeSubmission,
  },
  props: {
    hasImage: {
      type: Boolean,
      default: false,
    },
    questionImageLayoutMode: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
    }),
    hasTimeLimit() {
      return this.slideActive && this.slideActive.hasTimeLimit
    },
    isShowSubmissionControl() {
      const validScreen = (this.isPresenting || this.isBackstage)
        && !this.sharePresentation
      const validPresentationSetting = this.presentation
        && !JSON.parse(this.presentation.audiencePacing)

      return validScreen && validPresentationSetting
    },
    isInitTimeSubmission() {
      return this.slideActive
        && this.slideActive.id
        && this.slideActive.hasTimeLimit
    },
    isBackdropVisible() {
      const isToolbarVisible = (this.slideActive && this.slideActive.stopSubmission) || this.hasTimeLimit

      return isToolbarVisible && this.isPresenting
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    expandCollapseTrigger(val) {
      this.$emit('expandCollapseTrigger', val)
    },
    toggleSubmission() {
      this.$emit('hideFullScreen')
      const params = {
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
      }
      params.stopSubmission = !this.$store.state.slideActive.stopSubmission
      this.updateSlideActiveAction({
        stopSubmission: params.stopSubmission,
      })
      if (!params.stopSubmission && this.$store.state.slideActive.timeToAnswer) {
        const stopSubmissionTime = new Date().getTime() +
            this.$store.state.slideActive.timeToAnswer * 1000
        this.updateSlideActiveAction({
          stopSubmissionTime,
        })
        params.stopSubmissionTime = stopSubmissionTime
        params.timeToAnswer = this.$store.state.slideActive.timeToAnswer
      }
      this.$store.dispatch('setSyncPresentation', 1)
      params.presenting = this.$store.getters.isPresenting

      this.$http
        .put(Config.api.updateSlide + this.$store.state.slideActive.id, params)
        .then(
          () => {
            Util.mixpanelTracking(
              'Slide',
              'Edit setting',
              'Presenter edit setting stop submission',
              this.$store.state.slideActive.stopSubmission,
            )

            this.$store.dispatch('setSyncPresentation', 2)

            return true
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
        .catch(
          () => {
            // console.log(err)
          },
        )
    },
  },
}
</script>

<style lang="scss" scoped>
.block-wrapper {
  position: relative;
  height: 100%;
  border-radius: 16px;

  &.over, &:hover {
    background: rgba(0, 0, 0, 0.07);

    .toolbar {
      visibility: visible;
    }
  }
}

.toolbar {
  visibility: hidden;
  position: absolute;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  width: 100%;
  height: auto;
  pointer-events: none;
  color: #282E3E;
  font-size: 20px;
  pointer-events: auto;
  cursor: auto;
}

.toolbar-actions {
  position: relative;
  display: flex;
  width: fit-content;
  padding: 4px;
  align-items: center;
  border-radius: 52px;
  border: 1px solid #EBEBEB;
  background: #FFF;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);
}

.__icon {
  &:hover {
    @apply text-primary-100;
  }
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.submission-control {
  display: flex;
  align-items: center;
  line-height: initial;
  border-radius: 48px;
  background: #EBEBEB;

  .btn {
    border-radius: 48px;
    background: #348EF6;
    color: #fff;
    font-weight: 700;
    font-size: 20px;
    line-height: normal;
  }
}

.action-collapse {
  .action {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.action {
  cursor: pointer;
}
</style>
